import React from "react";

export default function Login() {
  return (
    <div>
      <section className="wrapper background-gif !bg-[#edf2fc]">
        <div className="container !pt-15 !pb-10 xl:!pt-[4.5rem] lg:!pt-[4.5rem] md:!pt-[4.5rem] xl:!pb-15 lg:!pb-15 md:!pb-15 !text-center">
          <div className="flex flex-wrap mx-[-15px]">
            <div className="md:w-10/12 lg:w-8/12 xl:w-8/12 w-full flex-[0_0_auto] px-[15px] max-w-full !mx-auto">
              <h1 className="text-[calc(1.365rem_+_1.38vw)] font-bold leading-[1.2] xl:text-[2.4rem] !mb-3">
                Login
              </h1>
              <p className="lead lg:!px-[1.25rem] xl:!px-[1.25rem] xxl:!px-[2rem] leading-[1.65] text-[0.9rem] font-medium max-w-full">
                ECHS (Ex-Servicemen Contributory Health Scheme).
              </p>
            </div>
            {/* /column */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container */}
      </section>
      {/* /section */}
      <section className="wrapper ">
        <div className="container py-[4.5rem] xl:!py-12 lg:!py-12 md:!py-12">
          <div className="flex flex-wrap mx-[-15px] mt-[-90px]">
            <div className="md:w-6/12 lg:w-4/12 xl:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[30px]">
              <a
                href="http://192.168.2.99:8080"
                target="_blank"
                className="card !shadow-[0_0.25rem_1.75rem_rgba(30,34,40,0.07)] lift !h-full"
              >
                <div className="card-body p-5 flex flex-row">
                  <div>
                    <span className=" flex items-center justify-center font-bold leading-[1.7] tracking-[-0.01rem] rounded-[100%] bg-[rgba(226,98,107)] opacity-100 text-white !w-[3rem] !h-[3rem] text-[1rem] !mr-4">
                      ADM
                    </span>
                  </div>
                  <div>
                    <span className="badge bg-[#e0e9fa] !text-[#3f78e0] rounded py-1 mb-2">
                      Admin
                    </span>
                    <h4 className="!mb-1">Brig Salil M.P.</h4>
                    <p className="mb-0 text-[#60697b]">Adm Cmdr ECHS Tvm</p>
                  </div>
                </div>
              </a>
            </div>
            {/*/column */}
            <div className="md:w-6/12 lg:w-4/12 xl:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[30px]">
              <a
                href="http://192.168.2.99:8080"
                target="_blank"
                className="card !shadow-[0_0.25rem_1.75rem_rgba(30,34,40,0.07)] lift !h-full"
              >
                <div className="card-body p-5 flex flex-row">
                  <div>
                    <span className=" flex items-center justify-center font-bold leading-[1.7] tracking-[-0.01rem] rounded-[100%] bg-[rgba(69,196,160)] opacity-100 text-white !w-[3rem] !h-[3rem] text-[1rem] !mr-4">
                      OIC
                    </span>
                  </div>
                  <div>
                    <span className="badge bg-[#e4f1f6] !text-[#54a8c7] rounded py-1 mb-2">
                      Admin
                    </span>
                    <h4 className="!mb-1"> Lt Col G Gopa Kumar</h4>
                    <p className="mb-0 text-[#60697b]">OIC , ECHS Tvm</p>
                  </div>
                </div>
              </a>
            </div>
            {/*/column */}
            <div className="md:w-6/12 lg:w-4/12 xl:w-4/12 w-full flex-[0_0_auto] px-[15px] max-w-full mt-[30px]">
              <a
                href="http://192.168.2.99"
                target="_blank"
                className="card !shadow-[0_0.25rem_1.75rem_rgba(30,34,40,0.07)] lift !h-full"
              >
                <div className="card-body p-5 flex flex-row">
                  <div>
                    <span className=" flex items-center justify-center font-bold leading-[1.7] tracking-[-0.01rem] rounded-[100%] bg-[rgba(250,183,88)] opacity-100 text-white !w-[3rem] !h-[3rem] text-[1rem] !mr-4">
                      CL
                    </span>
                  </div>
                  <div>
                    <span className="badge bg-[#e0e9fa] !text-[#3f78e0] rounded py-1 mb-2">
                      Guest
                    </span>
                    <h4 className="!mb-1">ECHS CELL LOGIN</h4>
                    <p className="mb-0 text-[#60697b]">ECHS Tvm</p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          {/*/.row */}
        </div>
        {/* /.container */}
      </section>
    </div>
  );
}
